// extracted by mini-css-extract-plugin
export default {"step":"vp_gwr9E","clickable":"vp_dLYMu","label":"vp_QKiL9","remarks":"vp_qytxE","start":"vp_XvhrY","end":"vp_LPXRT","new":"vp_BOtuG","blinking":"vp_AkNU7","ongoingTrip":"vp_NXS4Y"};